module.exports = __webpack_public_path__ + "img/SUPEROK_8.e07c17dc.jpg";